const GenericEngine = require('GenericEngine');
const Assert = require('Assert');
const AudioManager = require('AudioManager');
const AudioMap = require('AudioMap');
const PSState = require('PSState');
const PSEvents = require('PSEvents');
const SlotUI = require('SlotUI');
const MenuElements = SlotUI.MenuElements;

cc.Class({
    extends: cc.Component,

    properties: {
        button: cc.Toggle,
        isToggleReverse: false,
    },

    onDestroy() {
        PSEvents.unsubscribe(PSEvents.STATE_UPDATED, this.stateUpdatedHandler);
        PSEvents.unsubscribe(PSEvents.COMMON_INITIALIZED, this.commonInitializedHandler);
    },

    // LIFE-CYCLE CALLBACKS:

    onLoad() {
        this.stateUpdatedHandler = (data) => {
            this._stateUpdate(data);
        };
        PSEvents.subscribe(PSEvents.STATE_UPDATED, this.stateUpdatedHandler);

        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);

        if (GenericEngine.isInitialized()) {
            const data = PSState.get();

            this._handleEngineInitialise(data);
        } else {
            this.commonInitializedHandler = (data) => { this._handleEngineInitialise(data) };
            PSEvents.subscribe(PSEvents.COMMON_INITIALIZED, this.commonInitializedHandler);
        }

    },

    toggleSound() {
        const soundEnabled = !this._soundEnabled;

        PSState.set({ soundEnabled });
    },

    _handleEngineInitialise(data) {
        const soundConfig = SlotUI.getMenuElement(MenuElements.Audio);
        if (soundConfig && !soundConfig.enabled) {
            this.button.interactable = false;
            this.node.opacity = 0;
            return;
        }
        if (!Assert.isNull(data.soundEnabled)) {
            if (this._soundEnabled !== data.soundEnabled) {
                this._soundEnabled = data.soundEnabled;
                this.button.isChecked = data.soundEnabled ^ this.isToggleReverse;
            }
        }
    },


    _stateUpdate(data) {
        if (!Assert.isNull(data.soundEnabled)) {
            if (this._soundEnabled !== data.soundEnabled) {
                this._soundEnabled = data.soundEnabled;
                this.button.isChecked = data.soundEnabled ^ this.isToggleReverse;

                if (this._soundEnabled) {
                    this.audioManager.play(this.audioMap.introSoundButton);
                }
            }

        }
    }

});
